import React from 'react';
import {
  StyledContent,
  StyledDot,
} from '@/components/MobileApproval/HeaderContent/styles';

type P = {
  id: number;
  title: string;
  clicked: boolean;
  handleClick(id: number): void;
  newData?: boolean;
};
const HeaderContent = ({ title, clicked, handleClick, id, newData }: P) => {
  return (
    <StyledContent
      type={'button'}
      key={`Header-${title}`}
      clicked={clicked}
      onClick={() => handleClick(id)}
    >
      {title}
      {newData && <StyledDot />}
    </StyledContent>
  );
};
export default HeaderContent;
